<template>
  <div style="width:100%" ref="dom"></div>
</template>

<script>
import echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartLine",
  props: {
    option: Object
  },
  data() {
    return {
      dom: null,
      // option: {
      //   title: {
      //     text: "时效",
      //     x: "center"
      //   },
      //   toolbox: {
      //     feature: {
      //       saveAsImage: {}
      //     }
      //   },
      //   tooltip: {
      //     trigger: "axis"
      //   },
      //   legend: {
      //     data: [],
      //     bottom: 0
      //   },
      //   xAxis: {
      //     type: "category",
      //     boundaryGap: false,
      //     data: []
      //   },
      //   yAxis: {
      //     type: "value"
      //   },
      //   series: [
      //     {
      //       name: "Email",
      //       type: "line",
      //       data: []
      //     }
      //   ]
      // },
      country: [],
      series: []
    };
  },
  watch: {
    option: {
      handler(val) {
        this.$nextTick(() => {
          this.dom = echarts.init(this.$refs.dom, "tdTheme");
          this.dom.setOption(this.option, true);
          on(window, "resize", this.resize);
        });
      },
      deep: true
    }
  },
  methods: {
    resize() {
      this.dom.resize();
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.dom = echarts.init(this.$refs.dom, "tdTheme");
      this.dom.setOption(this.option, true);
      on(window, "resize", this.resize);
    });
  },
  beforeDestroy() {
    off(window, "resize", this.resize);
  }
};
</script>
